import http from '@/assets/common/http';
// 获取所有的一级大类和二级大类以及第一个一级大类对应的第一个二级大类下的所有产品
export function getTotal(data) {
  const params = {
    SERVICE_ID: '10040',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 点击二级大类获取产品
export function getProduct(data) {
  const params = {
    SERVICE_ID: '10040',
    OTYPE: 2,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 提交报价
export function priceSubmit(data) {
  const params = {
    SERVICE_ID: '10040',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 筛选产品
export function priceSearch(data) {
  const params = {
    SERVICE_ID: '10040',
    OTYPE: 7,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/givePrice.js